import React from 'react';
import '../styles/SobreNos.css'; // Importando o CSS específico para o componente
const SobreNos = () => {
  return (
    <div className="sobre-nos-container">
      <h1 className="sobre-nos-title">Sobre Nós</h1>
      <p className="sobre-nos-description">
        Bem-vindo à CR Mesquita! Somos uma empresa dedicada a oferecer os melhores serviços e produtos para nossos clientes.
      </p>
      <p className="sobre-nos-history">
        Com mais de 50 anos de experiência, nosso compromisso é com a qualidade e a satisfação de nossos clientes. Desde nossa fundação, temos trabalhado para nos tornar referência no setor de motores elétricos, oferecendo soluções completas e personalizadas.
      </p>

      <div className="sobre-nos-values">
        <h2>Nossos Valores</h2>
        <ul>
          <li><strong>Excelência:</strong> Buscamos sempre oferecer o melhor em tudo o que fazemos.</li>
          <li><strong>Inovação:</strong> Estamos constantemente aprimorando nossos processos e serviços.</li>
          <li><strong>Compromisso:</strong> Nosso foco é a satisfação e confiança de nossos clientes.</li>
        </ul>
      </div>

      <div className="sobre-nos-mission">
        <h2>Missão</h2>
        <p>
          Proporcionar soluções de alta qualidade em motores elétricos, garantindo a eficiência e a confiabilidade que nossos clientes merecem.
        </p>
      </div>

      <div className="sobre-nos-vision">
        <h2>Visão</h2>
        <p>
          Ser reconhecida como a principal referência no mercado de motores elétricos, destacando-se pela excelência e inovação.
        </p>
      </div>

      <div className="sobre-nos-team">
        <h2>Nossa Equipe</h2>
        <p>
          Contamos com uma equipe altamente qualificada e comprometida em atender às necessidades de nossos clientes com profissionalismo e dedicação.
        </p>
      </div>
    </div>
  );
};

export default SobreNos;